import { useEffect } from 'react';
import { isDev } from 'src/config';

declare global {
  interface Window {
    // Injected by the Google Analytics loader script in public/index.html.
    gtag: (command: 'event', eventName: string, params?: Record<string, unknown>) => void;
  }
}

export const gaEventEXPORT = (event: 'EXPORT_CSV' | 'EXPORT_PDF') => {
  !isDev && window.gtag('event', event);
};

export const gaEventCRUD = (event: 'ASSESSMENT' | 'SCENARIO', method: 'CREATE' | 'UPDATE' | 'DELETE') => {
  !isDev && window.gtag('event', event, { method: method });
};

export const gaEventUSER = (
  event: 'LOGIN' | 'LOGOUT' | 'SIGNUP' | 'CHANGE_PASSWORD' | 'CHANGE_EMAIL' | 'RESET_PASSWORD' | 'PROFILE_UPDATE',
  method?: 'CREDENTIALS' | 'GOOGLE' | 'MSO' | undefined,
) => {
  !isDev && window.gtag('event', event, { method: method });
};

type Title =
  | 'Cydea'
  | 'Cydea | My Assessments'
  | 'Cydea | Assessment'
  | 'Cydea | Scenario'
  | 'Get Started'
  | 'Cydea | Compare assessments'
  | 'Cydea | Compare scenarios'
  | string;

export const gaEventPageView = (title: Title) => {
  !isDev && window.gtag('event', 'page_view', { page_title: title });
};

export const useGaEventPageView = (title: Title) => {
  useEffect(() => {
    gaEventPageView(title);
  }, []);
};
